import { publicEncrypt } from 'crypto';

import bufferFrom from 'buffer-from';
import { fetchAndActivate, getRemoteConfig, getValue } from 'firebase/remote-config';

export const encrypt = async (app, data) => {
  const remoteConfig = getRemoteConfig(app);
  try {
    await fetchAndActivate(remoteConfig);
    const public_key = await getValue(remoteConfig, 'public_key')._value.replace(/\\n/g, '\n');
    const encodingData = publicEncrypt(public_key, bufferFrom(data)).toString('base64');
    return encodingData;
  } catch (error) {
    console.log(error);
  }
};
